import React from 'react';
import { Box, Text, VStack, Heading, Image, Container, Flex } from '@chakra-ui/react';
import { Link } from 'react-router-dom';
import { ArrowBackIcon } from '@chakra-ui/icons';
import Navbar from '../Components/Navbar';
import resume from '../icons/resume.png';
import { useNavigate } from 'react-router-dom';
import { ChevronLeftIcon } from '@chakra-ui/icons';
import NavigationButtons from '../Components/NavigationButtons'; // Import the NavigationButtons component



function ResumeResourcePage2() {
  const navigate = useNavigate()

  const handleBack = () => {
    navigate('/resume-resources')
  }
  const handleNext = () => {
    navigate('/resume-resource-page-3')
  }

  return (
    <Box>
      {/* Header */}
      <Box bg="#00D29D" w="100%" h="8vh" display="flex" alignItems="center" justifyContent="center">
        <Text fontSize="16px" fontWeight="semibold">Resources</Text>
      </Box>

      {/* Main Content */}
      <Container bg="white" p={6} maxW="container.md" fontFamily="Raleway">
        <VStack spacing={6} align="stretch">
          <Heading size="lg" color="#00D29D" fontFamily="Raleway">
            Crafting a Standout Resume
          </Heading>

          <Heading size="md" fontFamily="Raleway">Working Through the Template</Heading>
          
          <Text>
            This lesson will likely be the most comprehensive in our course, but it's also the 
            most valuable. We're dividing the McCombs Resume Template. I strongly recommend 
            downloading the resume template McCombs BBA Resume Template and opening it 
            work through this lesson. This will greatly assist you in formatting your resume 
            effectively.
          </Text>

          {/* New side-by-side layout */}
          <Box display="flex" alignItems="center" gap={4}>
            <Text flexGrow={1} fontStyle="italic">
              Note: This lesson will provide detailed descriptions of each section. We'll focus 
              more on formatting and the lesson.
            </Text>
            <Box flexShrink={0}>
              <Image 
                src={resume} 
                alt="Resume Icon"
                width="165px"
                height="134px"
              />
            </Box>
            
            
          </Box>

          <Heading size="lg" color="#00D29D" fontFamily="Raleway">
            Resume Breakdown
          </Heading>

          <Heading size="md" fontFamily="Raleway">Title</Heading>
          <Text>
            The title section of your resume is crucial. Your name should appear alone on the first line, 
            centered and following line should include your email address, phone number, and LinkedIn 
            address. Refer to the image
          </Text>
          <NavigationButtons onNext={handleNext} onBack={handleBack} />
        </VStack>
      </Container>
      <Box marginTop="50px">
        <Navbar/>
      </Box>
    </Box>
  );
}

export default ResumeResourcePage2;